import { queryOptions } from '@tanstack/react-query'

import { getHostPayReady, HostPayReadySearchParams } from './get-host-pay-ready'
import { getHostPayRooms } from './get-host-pay-rooms'

export const hostPayQueries = {
  all: () => ['host-pay'],
  hostPayRooms: () =>
    queryOptions({
      queryKey: [...hostPayQueries.all(), 'rooms'],
      queryFn: () => getHostPayRooms(),
    }),
  hostPayReady: (params: HostPayReadySearchParams) =>
    queryOptions({
      queryKey: [...hostPayQueries.all(), 'ready', params],
      queryFn: () => getHostPayReady(params),
    }),
}
